import React from 'react';

interface LifeRingIconProps {
  className?: string;
}

/** Life ring: the nav footer's Helpdesk (computer support) ticket button. */
const LifeRingIcon: React.FC<LifeRingIconProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="currentColor"
      style={{ transform: 'scale(0.85)' }}
    >
      <path d="M21.012,19.484c1.221-1.625,1.988-4.007,1.988-7.484s-.767-5.859-1.988-7.484l.293-.29c.394-.388,.397-1.021,.01-1.414-.39-.393-1.022-.397-1.414-.009l-.296,.292c-2.132-1.631-4.969-1.958-7.606-1.958s-5.473,.327-7.606,1.958l-.296-.292c-.393-.388-1.024-.384-1.414,.009-.388,.393-.384,1.026,.01,1.414l.293,.29c-1.221,1.625-1.988,4.007-1.988,7.484s.767,5.859,1.988,7.484l-.293,.29c-.394,.388-.397,1.02-.01,1.414,.487,.495,1.148,.287,1.414,.009l.296-.292c2.133,1.631,4.969,1.958,7.606,1.958s5.473-.327,7.606-1.958l.296,.292c.207,.217,.864,.536,1.414-.009,.375-.372,.384-1.026-.01-1.414l-.293-.29Zm-.012-7.484c0,2.771-.511,4.711-1.436,6.054l-2.934-2.896c.469-.813,.701-1.864,.701-3.158s-.232-2.344-.701-3.157l2.934-2.897c.925,1.343,1.436,3.284,1.436,6.054Zm-12.331,0c0-2.75,1.171-3.271,3.331-3.271s3.331,.521,3.331,3.271-1.171,3.271-3.331,3.271-3.331-.521-3.331-3.271ZM12,3.138c2.495,0,4.605,.322,6.153,1.392l-2.94,2.903c-.825-.471-1.895-.704-3.213-.704s-2.387,.233-3.213,.704l-2.94-2.903c1.548-1.07,3.658-1.392,6.153-1.392ZM3,12c0-2.771,.511-4.711,1.436-6.054l2.934,2.896c-.469,.813-.701,1.864-.701,3.158s.232,2.344,.701,3.158l-2.934,2.896c-.925-1.343-1.436-3.284-1.436-6.054Zm9,8.862c-2.495,0-4.605-.321-6.153-1.392l2.94-2.903c.825,.471,1.894,.704,3.213,.704s2.387-.233,3.213-.704l2.94,2.903c-1.548,1.07-3.658,1.392-6.153,1.392Z" />
    </svg>
  );
};

export default LifeRingIcon;
